import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";

function SaveGoogleDriveAssetService(token, data) {
    return axios.post(`${CURRENT_API_URL}/assetgallery/SaveGoogleDriveAssets`, data, {
        headers: {
            'Authorization': token,
        }
    }).then((res) => {
        return res.data;
    }).catch((error) => {
        console.log(error);
        if (error.response && error.response.data) {
            return error.response.data;
        }
        return {
            status: false,
            message: "An error occurred while saving Google Drive assets. Please try again later.",
        };
    });
}

export default SaveGoogleDriveAssetService;
